import { theme } from 'antd';
import { APP_TYPOGRAPHY_THEME } from '../../utils/appTypography';

export const APP_ACCENT = '#e11d2e';

// Brand layer: applied to the whole app (root ConfigProvider and static
// overlays). Light/dark appearance stays in AppTheme, which screens opt into.
export const APP_BRAND_THEME = {
  ...APP_TYPOGRAPHY_THEME,
  token: { ...APP_TYPOGRAPHY_THEME.token, colorPrimary: APP_ACCENT },
  components: {
    ...APP_TYPOGRAPHY_THEME.components,
    // Segmented ignores colorPrimary; give its selected option the same solid
    // accent as Radio.Group buttonStyle="solid".
    Segmented: { itemSelectedBg: APP_ACCENT, itemSelectedColor: '#ffffff' },
  },
};

// Custom styles use these instead of hex values. App.js sets them on the page
// root; AppTheme scopes override them for their appearance.
export const brandCssVariables = () => {
  const token = theme.getDesignToken(APP_BRAND_THEME);
  return {
    '--app-color-accent': token.colorPrimary,
    '--app-color-accent-hover': token.colorPrimaryHover,
    '--app-color-accent-bg': token.colorPrimaryBg,
  };
};
